<template>
  <section class="section has-text-dark has-background-white">
    <div class="container">
      <h1>Edit My Profile</h1>

      <div v-show="model.IsParticipation">
        <form @submit.prevent="validateBeforeSubmitPersonal('personal')" class="is-multiline" data-vv-scope="personal">
          <div class="columns">
            <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
              <div class="field">
                <label class="label required">{{labels.emailLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="email" v-model="model.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('personall.email') }" type="text" readonly>
                  <i v-show="errors.has('personall.email')" class="fa fa-warning"></i>
                  <span v-show="errors.has('personall.email')" class="help is-danger">{{errors.first('email')}}</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.passwordLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input v-model="model.Password" name="password" type="password" class="input">
                </div>
              </div>
            </div>
            <div class="column is-align-self-flex-end">
              <div class="field">
                <div class="control">
                  <button :class="{'button is-primary':true, 'is-loading disabled' : loadingpassword }" v-on:click="savePassword(model.Password)">Set Password</button>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
              <div class="field">
                <label class="label">{{labels.salutationLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <ul id="salutations">
                    <li v-for="item in model.SalutationList" :key="item.Text">
                      <label class="checkbox">
                        <input name="salutation" v-bind:value="item.Text" v-model="model.Salutation" type="radio" v-on:click="checkOthers(item.Text, 'Salutation')">
                        {{item.Text}}
                      </label>
                    </li>
                  </ul>
                </div>
                <input v-bind:disabled="isDisabled(isOtherSalutationActive)" name="salutation" v-model="model.OtherSalutation" type="text" :class="{'input': true}" />
              </div>
              <div class="field">
                <label class="label required">{{labels.firstNameLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="firstname" v-model="model.FirstName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('firstname') }" type="text">
                  <i v-show="errors.has('personal.firstname')" class="fa fa-warning"></i>
                  <span v-show="errors.has('personal.firstname')" class="help is-danger">{{errors.first('personal.firstname')}}</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.lastNameLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="lastname" v-model="model.LastName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('lastname') }" type="text">
                  <i v-show="errors.has('personal.lastname')" class="fa fa-warning"></i>
                  <span v-show="errors.has('personal.lastname')" class="help is-danger">{{errors.first('personal.lastname')}}</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.scienceEducationCommunityLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <ul id="genders" class="mb-1">
                    <li v-for="item in model.ScienceEducationCommunityList" :key="item.Text">
                      <label class="radio">
                        <input name="science" v-bind:value="item.Text" v-model="model.ScienceEducationCommunity" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text, 'Science')">
                        {{item.Text}}
                      </label>
                    </li>
                  </ul>
                </div>
                <input v-bind:required="isRequired(isOtherScienceActive)" v-bind:disabled="isDisabled(isOtherScienceActive)" name="science" v-model="model.OtherScience" type="text" :class="{'input': true, 'is-danger': errors.has('myprofile.science') }" />
                <i v-show="errors.has('personal.science')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('personal.science')">The role field is not valid.</span>
              </div>
              <div class="field">
                <label class="label required">{{labels.cityLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="city" v-model="model.City" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('personal.city') || cityInValid }" type="text">
                  <i v-show="errors.has('personal.city') || cityInValid" class="fa fa-warning"></i>
                  <span v-show="errors.has('personal.city')" class="help is-danger">{{errors.first('personal.city')}}</span>
                  <span v-show="cityInValid" class="help is-danger"> The city field may only contain alphabetic or numeric characters.</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.stateLabel}}</label>
                <div class="select is-fullwidth">
                  <select v-model="model.State">
                    <option v-for="option in model.States" v-validate="'required'" v-bind:value="option.Value" :class="{'input': true, 'is-danger': errors.first('personal.state')}">
                      {{ option.Text }}
                    </option>
                  </select>
                  <i v-show="errors.has('personal.state')" class="fa fa-warning"></i>
                  <span v-show="errors.has('personal.state')" class="help is-danger">{{errors.first('personal.state')}}</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.zipCodeLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="zipCode" v-model="model.ZipCode" v-bind:required="isRequiredPostCode" :class="{'input': true, 'is-danger': isRequiredPostCode || zipCodeInValid}" type="text" v-uppercase>
                  <i v-show="isRequiredPostCode || zipCodeInValid" class="fa fa-warning"></i>
                  <span v-show="isRequiredPostCode" class="help is-danger">The zip code field is required</span>
                  <span v-show="zipCodeInValid" class="help is-danger"> The zip code field is not valid.</span>
                </div>
              </div>
              <div class="field">
                <label class="label required">{{labels.affiliationLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <input name="affiliation" v-model="model.Affiliation" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('personal.affiliation') }" type="text">
                  <i v-show="errors.has('personal.affiliation')" class="fa fa-warning"></i>
                  <span v-show="errors.has('personal.affiliation')" class="help is-danger">{{errors.first('personal.affiliation')}}</span>
                </div>
              </div>
              <div class="field mb-6">
                <div class="control">
                  <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>


      <div class="tabs" v-show="model.IsCCI || model.IsSME">
        <ul>
          <li :class="{'is-active' : isPersonalActive}">
            <a @click="switchTabs('1')">Personal</a>
          </li>
          <li :class="{'is-active' : isExperienceActive}"><a @click="switchTabs('2')">Experience</a></li>
          <li :class="{'is-active' : isOrganisationActive}"><a @click="switchTabs('3')">Organization</a></li>
          <li :class="{'is-active' : isPrivacyActive}"><a @click="switchTabs('4')">Privacy</a></li>
          <li :class="{'is-active' : isMatchActive}" v-if="model.IsSME"><a @click="switchTabs('5')">Match</a></li>

        </ul>
      </div>


      <div v-show="model.IsCCI || model.IsSME">
        <div :class="{'is-block' : isPersonalActive,'is-hidden': !isPersonalActive}">
          <form @submit.prevent="validateBeforeSubmitPersonal('personall')" class="is-multiline" data-vv-scope="personall">

            <div class="columns">
              <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                <div class="field">
                  <label class="label required">{{labels.emailLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input name="email" v-model="model.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('personall.email') }" type="text" readonly>
                    <i v-show="errors.has('personall.email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('personall.email')" class="help is-danger">{{errors.first('personall.email')}}</span>
                  </div>
                </div>
                <div class="field">
                  <label class="label">{{labels.passwordLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input v-model="model.Password" name="password" type="password" class="input">
                  </div>
                </div>
              </div>
              <div class="column is-align-self-flex-end">
                <div class="field">
                  <div class="control">
                    <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" v-on:click="savePassword(model.Password)">Set Password</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                <div class="field">
                  <label class="label">{{labels.salutationLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <ul id="salutations">
                      <li v-for="item in model.SalutationList" :key="item.Text">
                        <label class="checkbox">
                          <input name="salutation" v-bind:value="item.Text" v-model="model.Salutation" type="radio" v-on:click="checkOthers(item.Text, 'Salutation')">
                          {{item.Text}}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <input v-bind:disabled="isDisabled(isOtherSalutationActive)" name="other" v-model="model.OtherSalutation" type="text" :class="{'input': true}" />
                </div>
                <div class="field">
                  <label class="label required">{{labels.firstNameLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input name="firstname" v-model="model.FirstName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('firstname') }" type="text">
                    <i v-show="errors.has('personall.firstname')" class="fa fa-warning"></i>
                    <span v-show="errors.has('personall.firstname')" class="help is-danger">{{errors.first('personall.firstname')}}</span>
                  </div>
                </div>
                <div class="field">
                  <label class="label required">{{labels.lastNameLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input name="lastname" v-model="model.LastName" v-validate="'required|alpha_spaces'" :class="{'input': true, 'is-danger': errors.has('lastname') }" type="text">
                    <i v-show="errors.has('personall.lastname')" class="fa fa-warning"></i>
                    <span v-show="errors.has('personall.lastname')" class="help is-danger">{{errors.first('personall.lastname')}}</span>
                  </div>
                </div>
                <div class="field">
                  <label class="label">LinkedIn</label>
                  <div class="control has-icon has-icon-right">
                    <input name="linkedin" v-model="model.LinkedIn" class="input" type="text">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Profile Image</label>
                  <div class="container" v-show="showImg">
                    <button type="button" class="clearButton button is-primary" v-on:click="showImg = false">
                      Remove Profile Image
                    </button>
                    <img v-bind:src="model.ImageUrl" />
                  </div>
                  <div class="control" v-show="!showImg">
                    <UploadImages :max="1" />
                  </div>
                </div>
                <div class="field">
                  <label class="label required">{{labels.phoneOrMobileNumberLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input name="phone" v-model="model.Phone" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('myprofile.phone') || phoneInValid }" type="text">
                    <i v-show="errors.has('personall.phone') || phoneInValid" class="fa fa-warning"></i>
                    <span v-show="errors.has('personall.phone')" class="help is-danger">The phone number field is required.</span>
                    <span v-show="phoneInValid" class="help is-danger">The phone field may only contain numeric characters, spaces, and the following characters ( ) and + </span>
                  </div>
                </div>
                <div class="field">
                  <label class="label required">{{labels.genderLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <ul id="genders">
                      <li v-for="item in model.GenderList" :key="item.Text">
                        <label class="radio">
                          <input name="gender" v-bind:value="item.Text" v-model="model.Gender" type="radio" v-validate="'required'">
                          {{item.Text}}
                        </label>
                      </li>
                    </ul>
                    <i v-show="errors.has('personall.gender')" class="fa fa-warning"></i>
                    <span class="help is-danger" v-show="errors.has('personall.gender')">{{errors.first('personall.gender')}}</span>
                  </div>
                </div>
                <div class="field">
                  <label class="label required">{{labels.ethnicityLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <ul id="ethnicities">
                      <li v-for="item in model.EthnicityList" :key="item.Text">
                        <label class="checkbox">
                          <input name="ethnicity" v-model="item.Selected" type="checkbox" v-validate="'required'">
                          {{item.Text}}
                        </label>
                      </li>
                    </ul>
                    <i v-show="errors.has('personall.ethnicity')" class="fa fa-warning"></i>
                    <span class="help is-danger" v-show="errors.has('personall.ethnicity')">{{errors.first('personall.ethnicity')}}</span>
                  </div>
                </div>
                <div class="field">
                  <label class="label">{{labels.bioLabel}}</label>
                  <p class="control has-icon has-icon-right">
                    <textarea name="bio" v-model="model.Bio" :class="{'input': true, 'is-danger': errors.has('personall') }" type="text"> </textarea>
                  </p>
                </div>
                <div class="field">
                  <div class="control">
                    <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div :class="{'is-block' : isExperienceActive,'is-hidden': !isExperienceActive}">

          <div v-show="model.IsCCI">
            <form @submit.prevent="validateBeforeSubmitExperience('cci-experience')" class="is-multiline" data-vv-scope="cci-experience">
              <div class="columns">
                <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                  <div class="field">
                    <label class="label required">{{labels.numberOfYearsTeachingLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="years" v-model="model.NumberOfTeachingYears" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('cci-experience.years') }" type="number" min="0" step="any">
                      <i v-show="errors.has('cci-experience.years')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-experience.years')" class="help is-danger">The Number of years teaching  field is mandatory.</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.numberOfYearsCollegeTeachingLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="collageyears" v-model="model.NumberOfCollegeTeachingYears" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('cci-experience.collageyears') }" type="number" min="0" step="any">
                      <i v-show="errors.has('cci-experience.collageyears')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-experience.collageyears')" class="help is-danger">The Number of years teaching community college astronomy  field is mandatory.</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.rolesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="roles" class="mb-1">
                        <li v-for="item in model.RoleList" :key="item.Text">
                          <label class="checkbox">
                            <input name="role" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Role')">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-experience.role')" class="fa fa-warning"></i>
                      <input :required="{isOtherRoleActive :'required'}" v-bind:disabled="isDisabled(isOtherRoleActive)" name="role" v-model="model.OtherRole" type="text" :class="{'input': true, 'is-danger': errors.has('cci-experience.role') }" />
                      <span class="help is-danger" v-show="errors.has('cci-experience.role')">{{errors.first('cci-experience.role')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.subjectAreaLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="subjects" class="mb-1">
                        <li v-for="item in model.SubjectAreaList" :key="item.Text">
                          <label class="radio">
                            <input name="subject" v-bind:value="item.Text" v-model="model.Subject" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Subject')">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-experience.subject')" class="fa fa-warning"></i>
                      <input v-bind:required="isRequired(isOtherSubjectActive)" v-bind:disabled="isDisabled(isOtherSubjectActive)" name="subject" v-model="model.OtherSubject" type="text" :class="{'input': true, 'is-danger': errors.has('cci-experience.subject') }" />
                      <span class="help is-danger" v-show="errors.has('cci-experience.subject')">{{errors.first('cci-experience.subject')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.classesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="classes" class="mb-1">
                        <li v-for="item in model.ClassList" :key="item.Text">
                          <input name="class" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Class')">
                          {{item.Text}}
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-experience.class')" class="fa fa-warning"></i>
                      <input v-bind:required="isRequired(isOtherClassActive)" v-bind:disabled="isDisabled(isOtherClassActive)" name="class" v-model="model.OtherClass" type="text" :class="{'input': true, 'is-danger': errors.has('cci-experience.class') }" />
                      <span class="help is-danger" v-show="errors.has('cci-experience.class')">{{errors.first('cci-experience.class')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.percentageOfTheAstronomyClassesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="percentage" v-model="model.PercentageOfTheAstronomyClasses" v-validate="'required|numeric'" :class="{'input': true, 'is-danger': errors.has('cci-experience.percentage') }" type="number">
                      <i v-show="errors.has('cci-experience.percentage')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-experience.percentage')" class="help is-danger">The percentage of the classes field must be numeric and may contain decimal points.</span>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit" id="my-profile-sbm">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-show="model.IsSME">
            <form @submit.prevent="validateBeforeSubmitExperience('sme-experience')" class="is-multiline" data-vv-scope="sme-experience">
              <div class="columns">
                <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                  <div class="field">
                    <label class="label required">{{labels.attendingDialogListLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="dialogs">
                        <li v-for="item in model.AttendingDialogList" :key="item.Text">
                          <label class="radio">
                            <input name="dialog" v-bind:value="item.Text" v-model="model.Dialog" type="radio" v-validate="'required'">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('sme-experience.dialog')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-experience.dialog')">An answer Yes or No is required</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.subjectAreaLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="subjects" class="mb-1">
                        <li v-for="item in model.SubjectAreaList" :key="item.Text">
                          <label class="radio">
                            <input name="subject" v-bind:value="item.Text" v-model="model.Subject" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Subject')">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <input v-bind:required="isRequired(isOtherSubjectActive)" v-bind:disabled="isDisabled(isOtherSubjectActive)" name="subject" v-model="model.OtherSubject" type="text" :class="{'input': true, 'is-danger': errors.has('sme-experience.subject') }" />
                      <i v-show="errors.has('sme-experience.subject')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-experience.subject')">{{errors.first('sme-experience.subject')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.workLabelLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="works" class="mb-1">
                        <li v-for="item in model.WorkList" :key="item.Text">
                          <input name="work" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Work')">
                          {{item.Text}}
                        </li>
                      </ul>
                      <input v-bind:required="isRequired(isOtherWorkActive)" v-bind:disabled="isDisabled(isOtherWorkActive)" name="work" v-model="model.OtherWork" type="text" :class="{'input': true, 'is-danger': errors.has('sme-experience.work') }" />
                      <i v-show="errors.has('sme-experience.work')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-experience.work')">{{errors.first('sme-experience.work')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.professionalRolesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="roles" class="mb-1">
                        <li v-for="item in model.ProfessionalRolesList" :key="item.Text">
                          <label class="checkbox">
                            <input name="role" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'ProfessionalRole')">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('sme-experience.role')" class="fa fa-warning"></i>
                      <input :required="{isOtherProfessionalRoleActive :'required'}" v-bind:disabled="isDisabled(isOtherProfessionalRoleActive)" name="role" v-model="model.OtherProfessionalRole" type="text" :class="{'input': true, 'is-danger': errors.has('sme-experience.role') }" />
                      <span class="help is-danger" v-show="errors.has('sme-experience.role')">{{errors.first('sme-experience.other_role')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.yourMainResearchFocusLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="research" v-model="model.YourMainResearchFocus" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('sme-experience.research') }" type="text">
                      <i v-show="errors.has('sme-experience.research')" class="fa fa-warning"></i>
                      <span v-show="errors.has('sme-experience.research')" class="help is-danger">{{errors.first('sme-experience.research')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.educationPublicExperienceLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="experiences" class="mb-1">
                        <li v-for="item in model.ExperienceList" :key="item.Text">
                          <input name="experience" v-bind:value="item.Text" v-model="model.Experience" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text,'Experience')">
                          {{item.Text}}
                        </li>
                      </ul>
                      <input v-bind:required="isRequired(isOtherExperienceActive)" v-bind:disabled="isDisabled(isOtherExperienceActive)" name="experience" v-model="model.OtherExperience" type="text" :class="{'input': true, 'is-danger': errors.has('sme-experience.experience') }" />
                      <i v-show="errors.has('sme-experience.experience')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-experience.experience')">{{errors.first('sme-experience.experience')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{labels.educationPublicEngagementExperienceDetailsLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="details" v-model="model.EducationPublicEngagementExperienceDetails" :class="{'input': true, 'is-danger': errors.has('sme-experience.details') }" type="text">
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.classesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="classes" class="mb-1">
                        <li v-for="item in model.ClassList" :key="item.Text">
                          <input name="class" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="checkOthers(item.Text,'Class')">
                          {{item.Text}}
                        </li>
                      </ul>
                      <input v-bind:required="isRequired(isOtherClassActive)" v-bind:disabled="isDisabled(isOtherClassActive)" name="class" v-model="model.OtherClass" type="text" :class="{'input': true, 'is-danger': errors.has('sme-experience.class') }" />
                      <i v-show="errors.has('sme-experience.class')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-experience.class')">{{errors.first('sme-experience.class')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{labels.yourInterestLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="interest" v-model="model.YourInterest" :class="{'input': true, 'is-danger': errors.has('sme-experience.interest') }" type="text">
                      <i v-show="errors.has('sme-experience.interest')" class="fa fa-warning"></i>
                      <span v-show="errors.has('sme-experience.interest')" class="help is-danger">{{errors.first('sme-experience.interest')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
        <div :class="{'is-block' : isOrganisationActive,'is-hidden': !isOrganisationActive}">
          <div v-show="model.IsCCI">
            <form @submit.prevent="validateBeforeSubmitOrganisation('cci-organisation')" class="is-multiline" data-vv-scope="cci-organisation">

              <div class="field">
                <label class="label required">{{labels.scienceEducationCommunityLabel}}</label>
                <div class="control has-icon has-icon-right">
                  <ul id="genders" class="mb-1">
                    <li v-for="item in model.ScienceEducationCommunityList" :key="item.Text">
                      <label class="radio">
                        <input name="science" v-bind:value="item.Text" v-model="model.ScienceEducationCommunity" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text, 'Science')">
                        {{item.Text}}
                      </label>
                    </li>
                  </ul>
                </div>
                <input v-bind:required="isRequired(isOtherScienceActive)" v-bind:disabled="isDisabled(isOtherScienceActive)" name="science" v-model="model.OtherScience" type="text" :class="{'input': true, 'is-danger': errors.has('cci-organisation.science') }" />
                <i v-show="errors.has('cci-organisation.science')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('cci-organisation.science')">{{errors.first('cci-organisation.science')}}</span>
              </div>
              <div class="columns">
                <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                  <div class="field">
                    <label class="label required">{{labels.cityLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="city" v-model="model.City" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('cci-organisation.city') }" type="text">
                      <i v-show="errors.has('cci-organisation.city')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-organisation.city')" class="help is-danger">{{errors.first('cci-organisation.city')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.stateLabel}}</label>
                    <div class="select is-fullwidth">
                      <select v-model="model.State">
                        <option v-for="option in model.States" v-validate="'required'" v-bind:value="option.Value">
                          {{ option.Text }}
                        </option>
                      </select>
                      <i v-show="errors.has('cci-organisation.state')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-organisation.state')" class="help is-danger">{{errors.first('cci-organisation.state')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.zipCodeLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="zipCode" v-model="model.ZipCode" v-bind:required="isRequiredPostCode" :class="{'input xs': true, 'is-danger': isRequiredPostCode || zipCodeInValid }" type="text">
                      <i v-show="isRequiredPostCode || zipCodeInValid" class="fa fa-warning"></i>
                      <span v-show="isRequiredPostCode" class="help is-danger">The zip code field is required</span>
                      <span v-show="zipCodeInValid" class="help is-danger">The zip code field is not valid.</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.affiliationLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="affiliation" v-model="model.Affiliation" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('cci-organisation.affiliation') }" type="text">
                      <i v-show="errors.has('cci-organisation.affiliation')" class="fa fa-warning"></i>
                      <span v-show="errors.has('cci-organisation.affiliation')" class="help is-danger">{{errors.first('cci-organisation.affiliation')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.classificationOfCollegeAreaLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="roles">
                        <li v-for="item in model.CollegeAreaClassificationList" :key="item.Text">
                          <label class="radio">
                            <input name="classification" v-bind:value="item.Text" v-model="model.Classification" type="radio" v-validate="'required'">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-organisation.classification')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('cci-organisation.classification')">{{errors.first('cci-organisation.classification')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.collegesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="colleges">
                        <li v-for="item in model.CollegeList" :key="item.Text">
                          <label class="radio">
                            <input name="college" v-bind:value="item.Text" v-model="model.College" type="radio" v-validate="'required'">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-organisation.college')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('cci-organisation.college')">{{errors.first('cci-organisation.college')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.enrolmentOfMainCollegeLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="mainCollegeEnrolments" class="mb-1">
                        <li v-for="item in model.MainCollegeEnrolmentList" :key="item.Text">
                          <label class="radio">
                            <input name="enrolment" v-bind:value="item.Text" v-model="model.Enrolment" type="radio" v-validate="'required'">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <span class="help is-danger" v-show="errors.has('cci-organisation.enrolment')">{{errors.first('cci-organisation.enrolment')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.collegeCampusDialogLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="dialogs" class="mb-1">
                        <li v-for="item in model.CollegeCampusDialogList" :key="item.Text">
                          <label class="radio">
                            <input name="dialog" v-bind:value="item.Text" v-model="model.Dialog" type="radio" v-validate="'required'">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <i v-show="errors.has('cci-organisation.dialog')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('cci-organisation.dialog')">>An answer Yes or No is required</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label">{{labels.otherCollegesLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="college" v-model="model.OtherCollege" :class="{'input': true }" type="text">
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-show="model.IsSME">
            <form @submit.prevent="validateBeforeSubmitOrganisation('sme-organisation')" class="is-multiline" data-vv-scope="sme-organisation">
              <div class="columns">
                <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                  <div class="field">
                    <label class="label required">{{labels.scienceEducationCommunityLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <ul id="genders" class="mb-1">
                        <li v-for="item in model.ScienceEducationCommunityList" :key="item.Text">
                          <label class="radio">
                            <input name="science" v-bind:value="item.Text" v-model="model.ScienceEducationCommunity" type="radio" v-validate="'required'" v-on:click="checkOthers(item.Text, 'Science')">
                            {{item.Text}}
                          </label>
                        </li>
                      </ul>
                      <input v-bind:required="isRequired(isOtherScienceActive)" v-bind:disabled="isDisabled(isOtherScienceActive)" name="science" v-model="model.OtherScience" type="text" :class="{'input': true, 'is-danger': errors.has('sme-organisation.science') }" />
                      <i v-show="errors.has('sme-organisation.science')" class="fa fa-warning"></i>
                      <span class="help is-danger" v-show="errors.has('sme-organisation.science')">{{errors.first('sme-organisation.science')}}</span>
                    </div>

                  </div>
                  <div class="field">
                    <label class="label required">{{labels.cityLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="city" v-model="model.City" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('sme-organisation.city') }" type="text">
                      <i v-show="errors.has('sme-organisation.city')" class="fa fa-warning"></i>
                      <span v-show="errors.has('sme-organisation.city')" class="help is-danger">{{errors.first('sme-organisation.city')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.stateLabel}}</label>
                    <div class="select is-fullwidth">
                      <select v-model="model.State" :class="{'input': true, 'is-danger': errors.first('sme-organisation.state') || stateInvalid }">
                        <option v-for="option in model.States" v-validate="'required'" v-bind:value="option.Value">
                          {{ option.Text }}
                        </option>
                      </select>
                      <i v-show="errors.has('sme-organisation.state') || stateInvalid " class="fa fa-warning"></i>
                      <span v-show="errors.has('sme-organisation.state') || stateInvalid" class="help is-danger">The state field is required.</span>

                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.zipCodeLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="zipCode" v-model="model.ZipCode" v-bind:required="isRequiredPostCode" :class="{'input xs': true, 'is-danger': isRequiredPostCode || zipCodeInValid }" type="text">
                      <i v-show="isRequiredPostCode || zipCodeInValid" class="fa fa-warning"></i>
                      <span v-show="isRequiredPostCode" class="help is-danger">The zip code field is required</span>
                      <span v-show="zipCodeInValid" class="help is-danger">The zip code field is not valid.</span>
                    </div>
                  </div>
                  <div class="field">
                    <label class="label required">{{labels.affiliationLabel}}</label>
                    <div class="control has-icon has-icon-right">
                      <input name="affiliation" v-model="model.Affiliation" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('sme-organisation.affiliation') }" type="text">
                      <i v-show="errors.has('sme-organisation.affiliation')" class="fa fa-warning"></i>
                      <span v-show="errors.has('sme-organisation.affiliation')" class="help is-danger">{{errors.first('sme-organisation.affiliation')}}</span>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div :class="{'is-block' : isPrivacyActive,'is-hidden': !isPrivacyActive}">
          <div v-show="model.IsCCI || model.IsSME">
            <form @submit.prevent="validateBeforeSubmitPrivacy('privacy')" class="is-multiline" data-vv-scope="privacy">

              <div class="field">
                <label class="label required">
                  Display the following information on my profile
                </label>
                <div class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayName" type="checkbox" v-on:click="checkMyProfileInfo('Name')">
                    Name
                  </label>
                </div>
                <div class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayEmail" type="checkbox" v-on:click="checkMyProfileInfo('Email')">
                    Email
                  </label>
                </div>
                <div class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayPhone" type="checkbox" v-on:click="checkMyProfileInfo('Phone')">
                    Phone
                  </label>
                </div>
                <div v-show="model.IsSME" class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayAffiliation" type="checkbox" v-on:click="checkMyProfileInfo('Affiliation')">
                    Affiliation
                  </label>
                </div>
                <div v-show="model.IsCCI" class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayRoleAndCollege" type="checkbox" v-on:click="checkMyProfileInfo('Role and College')">
                    Role and College
                  </label>
                </div>
                <div v-show="model.IsSME" class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayExperience" type="checkbox" v-on:click="checkMyProfileInfo('Experience')">
                    Experience
                  </label>
                </div>
                <div v-show="model.IsCCI" class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayTeachingExperience" type="checkbox" v-on:click="checkMyProfileInfo('Teaching Experience')">
                    Teaching Experience
                  </label>
                </div>
                <div class="control has-icon has-icon-right">
                  <label class="checkbox">
                    <input v-model="model.DisplayBiography" type="checkbox" v-on:click="checkMyProfileInfo('Biography')">
                    Biography
                  </label>
                </div>
              </div>
              <div class="field mt-6 mb-2">
                <strong>Your Profile as It Appears to Others:</strong>
                <h1 v-show="model.DisplayName"><span v-show="!isOtherSalutationActive && model.Salutation">{{model.Salutation}}</span> <span v-show="isOtherSalutationActive && model.OtherSalutation">{{model.OtherSalutation}}</span> {{model.FirstName}} {{model.LastName}}</h1>
                <h1 v-show="!model.DisplayName"><span v-show="!isOtherSalutationActive && model.Salutation">{{model.Salutation}}</span> <span v-show="isOtherSalutationActive && model.OtherSalutation">{{model.OtherSalutation}}</span> {{firstNameShortened}} {{lastNameShortened}}</h1>
                <p class="has-margin-top-3-desktop" v-show="model.DisplayEmail"><strong>{{labels.emailLabel}}</strong>: {{model.Email}}</p>
                <p class="has-margin-top-3-desktop" v-show="model.DisplayEmail && model.LinkedIn"><strong>LinkedIn</strong>: <a v-bind:href="'//' + model.LinkedIn" target="_blank">{{model.LinkedIn}}</a></p>
                <p class="has-margin-top-3-desktop" v-show="model.DisplayPhone"><strong>{{labels.phoneOrMobileNumberLabel}}</strong>: {{model.Phone}}</p>
                <p class="has-margin-top-3-desktop" v-show="model.DisplayRoleAndCollege"><strong>Roles</strong>: <span><span v-show="isOtherScienceActive">{{model.OtherScience}}</span><span v-show="!isOtherScienceActive">{{model.ScienceEducationCommunity}}</span> at {{model.Affiliation}}<span v-show="model.OtherCollege">, {{model.OtherCollege}}</span> College, {{model.State}}</span></p>
                <div class="has-margin-top-3-desktop" v-show="model.DisplayTeachingExperience">
                  <p v-show="model.NumberOfTeachingYears"><strong>Years Teaching</strong>: {{model.NumberOfTeachingYears}}</p>
                  <p v-show="model.NumberOfCollegeTeachingYears"><strong>Years Teaching Astronomy</strong>: {{model.NumberOfCollegeTeachingYears}}</p>
                  <p<strong>Classes Taught</strong>: <span>{{model.Classes}}</span></p>
                </div>
                <p v-show="model.DisplayExperience"><strong>Highest degree</strong>: <span v-show="!isOtherSubjectActive">{{model.Subject}}</span> <span v-show="isOtherSubjectActive">{{model.OtherSubject}}</span></p>
                <p v-show="model.DisplayExperience && model.YourInterest"><strong>Main Focus</strong>: <span>{{model.YourMainResearchFocus}}</span></p>
                <p v-show="model.DisplayAffiliation"><strong>Affiliation</strong>: <span>{{model.Affiliation}}</span></p>
                <div class="has-margin-top-3-desktop" v-show="model.DisplayBiography">
                  <h2 v-if="model.Bio">Bio</h2>
                  <p>
                    {{model.Bio}}
                  </p>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
                </div>
              </div>
          </div>
          </form>
        </div>
      </div>

      <div :class="{'is-block' : isMatchActive,'is-hidden': !isMatchActive}">
        <div v-show="model.IsSME || model.IsCCI">
          <form @submit.prevent="validateBeforeSubmitMatch('sme-match')" class="is-multiline" data-vv-scope="sme-match">

            <div class="field">
              <label class="label required">{{labels.typeOfInteractionLabel}}</label>
              <div class="control has-icon has-icon-right">
                <ul id="types" class="mb-1">
                  <li v-for="item in model.TypeOfInteractions" :key="item.Text">
                    <input name="type" v-model="item.Selected" type="checkbox" v-validate="'required'">
                    {{item.Text}}
                  </li>
                </ul>
                <i v-show="errors.has('sme-match.type')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('sme-match.type')">At list one type of interaction should be selected</span>
              </div>
            </div>

            <div class="field">
              <label class="label required">{{labels.topicsLabel}}</label>
              <div class="control has-icon has-icon-right">
                <ul id="topics" class="mb-1">
                  <li v-for="item in model.Topics" :key="item.Text">
                    <input name="topic" v-model="item.Selected" type="checkbox" v-validate="'required'">
                    {{item.Text}}
                  </li>
                </ul>
                <i v-show="errors.has('sme-match.topic')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('sme-match.topic')">At list one topic should be selected</span>
              </div>
            </div>

            <div class="field">
              <label class="label required">{{labels.approximateAvailabilityLabel}}</label>
              <div class="control has-icon has-icon-right">
                <ul id="availabilities" class="mb-1">
                  <li v-for="item in model.ApproximateAvailabilities" :key="item.Text">
                    <input name="availability" v-model="item.Selected" type="checkbox" v-validate="'required'" v-on:click="uncheckAnyTime(item.Text)">
                    {{item.Text}}
                  </li>
                </ul>
                <i v-show="errors.has('sme-match.availability')" class="fa fa-warning"></i>
                <span class="help is-danger" v-show="errors.has('sme-match.availability')">At list one approximate availability should be selected</span>
              </div>
            </div>
            <div class="columns">
              <div class="column is-two-thirds-tablet is-half-desktop is-one-third-widescreen">
                <div class="field">
                  <label class="label required">{{labels.limitRequestsLabel}}</label>
                  <div class="control has-icon has-icon-right">
                    <input name="limit" v-model="model.LimitRequests" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('sme-match.limit') }" type="number" min="0" step="any">
                    <i v-show="errors.has('sme-match.limit')" class="fa fa-warning"></i>
                    <span v-show="errors.has('sme-match.limit')" class="help is-danger">Limit Requests number should be greater than or equal to 0</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <button :class="{'button is-primary':true, 'is-loading disabled' : loading }" type="submit">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Transition name="modal">
      <div v-if="showModal" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <h4>Details updated successfully</h4>
              <button class="button is-primary modal-default-button" @click="showModal = false">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </section>
</template>


<script>
  import UploadImages from "vue-upload-drop-images"

  export default {
    components: {
      UploadImages
    },
    name: 'MyProfile',
    data() {
      return {
        showModal: false,
        model: {
        },
        errored: false,
        labels: [],
        files: '',
        isOtherRoleActive: false,
        isOtherScienceActive: false,
        isPersonalActive: true,
        isExperienceActive: false,
        isOrganisationActive: false,
        isPrivacyActive: false,
        isMatchActive: false,
        isOtherRoleActive: false,
        isOtherScienceActive: false,
        isOtherSubjectActive: false,
        isOtherWorkActive: false,
        isOtherExperienceActive: false,
        isOtherProfessionalRoleActive: false,
        loading: false,
        loadingpassword: false,
        showImg: false,
        isOtherSalutationActive: false,
        firstNameShortened: null,
        lastNameShortened: null
      }
    },
    computed: {
      cityInValid() {
        return !(!this.model.City || /^\s*$/.test(this.model.City)) && /^[A-Za-z0-9\s]+$/.test(this.model.City) == false;
      },
      zipCodeInValid() {
        return !(!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && this.model.State != null && this.model.State != "Outside the United States" ? /^[/\d]{5}?$/.test(this.model.ZipCode) == false : !(!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && /^[A-Za-z0-9_\-\s]+$/.test(this.model.ZipCode) == false;
      },
      affiliationInValid() {
        return !(!this.model.Affiliation || /^\s*$/.test(this.model.Affiliation)) && /^[A-Za-z0-9\s]+$/.test(this.model.Affiliation) == false;
      },
      stateInvalid() {
        return !this.model.State && this.errored;
      },
      phoneInValid() {
        return !(!this.model.Phone || /^\s*$/.test(this.model.Phone)) && /^(?=.*[0-9])[+()0-9\s]+$/.test(this.model.Phone) == false;
      },
      isRequiredPostCode() {
        return (!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && this.model.State != null && this.model.State != "Outside the United States" ? true : false;
      },
      isRequiredAvailability() {
        return (!this.model.ZipCode || /^\s*$/.test(this.model.ZipCode)) && this.model.State != null && this.model.State != "Outside the United States" ? true : false;
      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/MyProfileSurface/MyProfile')
        .then(response => {
          this.model = response.data.model;
          this.labels = response.data.labels;
          if (this.model.OtherProfessionalRole)
            this.isOtherProfessionalRoleActive = true;
          if (this.model.OtherScience)
            this.isOtherScienceActive = true;
          if (this.model.OtherClass)
            this.isOtherClassActive = true;
          if (this.model.OtherProfessionalRole)
            this.isOtherProfessionalRoleActive = true;
          if (this.model.OtherRole)
            this.isOtherRoleActive = true;
          if (this.model.OtherExperience)
            this.isOtherExperienceActive = true;
          if (this.model.OtherWork)
            this.isOtherWorkActive = true;
          if (this.model.OtherSubject)
            this.isOtherSubjectActive = true;
          if (this.model.OtherSalutation)
            this.isOtherSalutationActive = true;

          if (this.model.ImageUrl != null)
            this.showImg = true;

          this.firstNameShortened = this.model.FirstName.charAt(0);
          this.lastNameShortened = this.model.LastName.charAt(0);

        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmitPersonal(scope) {
        this.errored = true;
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            let formData = new FormData();
            formData.append('IsParticipation', this.model.IsParticipation);
            formData.append('Email', this.model.Email);
            formData.append('FirstName', this.model.FirstName);
            formData.append('LastName', this.model.LastName);
            formData.append('Salutation', this.model.Salutation);
            formData.append('Affiliation', this.model.Affiliation);
            formData.append('Photo', $("input[type='file']")[0].files[0]);
            formData.append('Phone', this.model.Phone);
            formData.append('ScienceEducationCommunity', this.model.ScienceEducationCommunity);
            formData.append('OtherScience', this.model.OtherScience);
            formData.append('City', this.model.City);
            formData.append('State', this.model.State);
            formData.append('ZipCode', this.model.ZipCode);
            formData.append('Afflication', this.model.Afflication);
            formData.append('Gender', this.model.Gender);
            formData.append('Ethnicity', JSON.stringify(this.model.EthnicityList));
            formData.append('OtherSalutation', this.model.OtherSalutation);
            formData.append('LinkedIn', this.model.LinkedIn);
            formData.append('Bio', this.model.Bio);
            formData.append('ImageUrl', this.showImg ? this.model.ImageUrl : null);




            this.$http.post('/umbraco/surface/MyProfileSurface/SavePersonalInfo',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else {
                  this.loading = false;
                  this.showModal = true;
                }

              })
              .catch(function (error) {
              });
            return;
          }
        });
      },
      validateBeforeSubmitExperience(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            let formData = new FormData();
            formData.append('IsSME', this.model.IsSME);
            formData.append('Email', this.model.Email);
            formData.append('Dialog', this.model.Dialog);
            formData.append('Subject', this.model.Subject);
            formData.append('OtherSubject', this.model.OtherSubject);
            formData.append('YourMainResearchFocus', this.model.YourMainResearchFocus);
            formData.append('Experience', this.model.Experience);
            formData.append('OtherExperience', this.model.OtherExperience);
            formData.append('EducationPublicEngagementExperienceDetails', this.model.EducationPublicEngagementExperienceDetails);
            formData.append('YourInterest', this.model.YourInterest);
            formData.append('OtherProfessionalRole', this.model.OtherProfessionalRole);
            formData.append('ProfessionalRolesList', JSON.stringify(this.model.ProfessionalRolesList));
            formData.append('Classes', JSON.stringify(this.model.ClassList));
            formData.append('OtherClass', this.model.OtherClass);
            formData.append('Works', JSON.stringify(this.model.WorkList));
            formData.append('OtherWork', this.model.OtherWork);
            formData.append('NumberOfTeachingYears', this.model.NumberOfTeachingYears);
            formData.append('NumberOfCollegeTeachingYears', this.model.NumberOfCollegeTeachingYears);
            formData.append('PercentageOfTheAstronomyClasses', this.model.PercentageOfTheAstronomyClasses);
            formData.append('NumberOfTeachingYears', this.model.NumberOfTeachingYears);
            formData.append('Roles', JSON.stringify(this.model.RoleList));
            formData.append('OtherRole', this.model.OtherRole);
            formData.append('ProfessionalRoles', JSON.stringify(this.model.ProfessionalRolesList));
            formData.append('OtherProfessionalRole', this.model.OtherProfessionalRole);

            this.$http.post('/umbraco/surface/MyProfileSurface/SaveExperienceInfo',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else {
                  this.loading = false;
                  this.showModal = true;
                }
              })
              .catch(function (error) {
              });
            return;
          }
        });
      },
      validateBeforeSubmitOrganisation(scope) {
        this.$validator.validateAll(scope).then((result) => {
          console.log(result);
          if (result) {
            this.loading = true;
            let formData = new FormData();
            formData.append('IsSME', this.model.IsSME);
            formData.append('Email', this.model.Email);
            formData.append('OtherScience', this.model.OtherScience);
            formData.append('ScienceEducationCommunity', this.model.ScienceEducationCommunity);
            formData.append('City', this.model.City);
            formData.append('State', this.model.State);
            formData.append('ZipCode', this.model.ZipCode);
            formData.append('Affiliation', this.model.Affiliation);
            formData.append('Classification', this.model.Classification);
            formData.append('College', this.model.College);
            formData.append('Enrolment', this.model.Enrolment);
            formData.append('Dialog', this.model.Dialog);
            formData.append('OtherCollege', this.model.OtherCollege);

            this.$http.post('/umbraco/surface/MyProfileSurface/SaveOrganisationInfo',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else {
                  this.loading = false;
                  this.showModal = true;
                }
              })
              .catch(function (error) {
              });
            return;
          }
        });
      },
      validateBeforeSubmitMatch(scope) {
        this.errored = true;
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            let formData = new FormData();
            formData.append('Email', this.model.Email);
            formData.append('LimitRequests', this.model.LimitRequests);
            formData.append('ApproximateAvailabilities', JSON.stringify(this.model.ApproximateAvailabilities));
            formData.append('Topics', JSON.stringify(this.model.Topics));
            formData.append('TypeOfInteractions', JSON.stringify(this.model.TypeOfInteractions));

            this.$http.post('/umbraco/surface/MyProfileSurface/SaveMatchInfo',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else {
                  this.loading = false;
                  this.showModal = true;
                }

              })
              .catch(function (error) {
              });
            return;
          }
        });
      },
      validateBeforeSubmitPrivacy(scope) {
        this.errored = true;
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            let formData = new FormData();
            formData.append('Email', this.model.Email);
            formData.append('DisplayName', this.model.DisplayName);
            formData.append('DisplayEmail', this.model.DisplayEmail);
            formData.append('DisplayPhone', this.model.DisplayPhone);
            formData.append('DisplayAffiliation', this.model.DisplayAffiliation);
            formData.append('DisplayRoleAndCollege', this.model.DisplayRoleAndCollege);
            formData.append('DisplayExperience', this.model.DisplayExperience);
            formData.append('DisplayTeachingExperience', this.model.DisplayTeachingExperience);
            formData.append('DisplayBiography', this.model.DisplayBiography);

            this.$http.post('/umbraco/surface/MyProfileSurface/SavePrivacyInfo',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                if (response.data.error)
                  this.loading = false;
                else {
                  this.loading = false;
                  this.showModal = true;
                }

              })
              .catch(function (error) {
              });
            return;
          }
        });
      },
      savePassword() {
        this.loadingpassword = true;
        this.$http.post
          (
            '/umbraco/surface/MyProfileSurface/SavePassword',
            this.model
          )
          .then(response => {
            if (response.data.error)
              this.loadingpassword = false;
            else {
              this.loadingpassword = false;
              alert('Details updated successfully');
            }
          })
          .catch(function (error) {
          });
        return;

      },
      switchTabs(tab) {

        if (tab === '1') {
          this.isPersonalActive = true;
          this.isExperienceActive = false;
          this.isOrganisationActive = false;
          this.isPrivacyActive = false;
          this.isMatchActive = false;
        } else if (tab === '2') {
          this.isPersonalActive = false;
          this.isExperienceActive = true;
          this.isOrganisationActive = false;
          this.isPrivacyActive = false;
          this.isMatchActive = false;
        }
        else if (tab === '3') {
          this.isPersonalActive = false;
          this.isExperienceActive = false;
          this.isOrganisationActive = true;
          this.isPrivacyActive = false;
          this.isMatchActive = false;
        }
        else if (tab === '4') {
          this.isPersonalActive = false;
          this.isExperienceActive = false;
          this.isOrganisationActive = false;
          this.isPrivacyActive = true;
          this.isMatchActive = false;

        }
        else {
          this.isPersonalActive = false;
          this.isExperienceActive = false;
          this.isOrganisationActive = false;
          this.isPrivacyActive = false;
          this.isMatchActive = true;

        }
      },
      isDisabled(value) {
        return value ? null : "disabled";
      },
      isRequired(value) {
        return value ? true : false;
      },
      checkOthers(value, type) {
        switch (type) {
          case "Subject":
            if (value == "Other:")
              this.isOtherSubjectActive = true;
            else {
              this.isOtherSubjectActive = false;
              this.model.OtherSubject = "";
            }
            break;
          case "Work":
            if (value == "Other:") {
              if (this.isOtherWorkActive) {
                this.model.OtherWork = "";
                this.isOtherWorkActive = false;
              }
              this.isOtherWorkActive = true;
            }
            break;
          case "Experience":
            if (value == "Other:")
              this.isOtherExperienceActive = true;
            else {
              this.isOtherExperienceActive = false;
              this.model.OtherExperience = "";
            }
            break;
          case "Salutation":
            if (value == "Other:")
              this.isOtherSalutationActive = true;
            else {
              this.isOtherSalutationActive = false;
              this.model.OtherSalutation = "";
            }
            break;
          case "Role":
            if (value == "Other:") {
              if (this.isOtherRoleActive) {
                this.model.OtherRole = "";
                this.isOtherRoleActive = false;

              }
              else
                this.isOtherRoleActive = true;

            }
            break;
          case "Class":
            if (value == "Other:") {
              if (this.isOtherClassActive) {
                this.model.OtherClass = "";
                this.isOtherClassActive = false;
              }
              else
                this.isOtherClassActive = true;
            }
            break;
          case "Science":
            if (value == "Other:")
              this.isOtherScienceActive = true;
            else {
              this.model.OtherScience = "";
              this.isOtherScienceActive = false;
            }
            break;
          case "ProfessionalRole":
            if (value == "Other:") {
              if (this.isOtherProfessionalRoleActive) {
                this.model.OtherProfessionalRole = "";
                this.isOtherProfessionalRoleActive = false;
              }
              else
                this.isOtherProfessionalRoleActive = true;
            }
        }
      },
      checkMyProfileInfo(value) {
        switch (value) {
          case "Name":
            if (this.model.DisplayName)
              this.model.DisplayName = false;
            else
              this.model.DisplayName = true;
            break;
          case "Email":
            if (this.model.DisplayEmail)
              this.model.DisplayEmail = false;
            else
              this.model.DisplayEmail = true;
            break;
          case "Affiliation":
            if (this.model.DisplayAffiliation)
              this.model.DisplayAffiliation = false;
            else
              this.model.DisplayAffiliation = true;
            break;
          case "Phone":
            if (this.model.DisplayPhone)
              this.model.DisplayPhone = false;
            else
              this.model.DisplayPhone = true;
            break;
          case "Teaching Experience":
            if (this.model.DisplayTeachingExperience)
              this.model.DisplayTeachingExperience = false;
            else
              this.model.DisplayTeachingExperience = true;
            break;
          case "Role and College":
            if (this.model.DisplayRoleAndCollege)
              this.model.DisplayRoleAndCollege = false;
            else
              this.model.DisplayRoleAndCollege = true;
            break;
          case "Experience":
            if (this.model.DisplayExperience)
              this.model.DisplayExperience = false;
            else
              this.model.DisplayExperience = true;
            break;
          case "Biography":
            if (this.model.DisplayBiography)
              this.model.DisplayBiography = false;
            else
              this.model.DisplayBiography = true;
            break;
        }
      },
      uncheckAnyTime(text) {
        if (text == 'Any Time') {
          this.model.ApproximateAvailabilities.forEach((item) => item.Selected = false);
        }
        else {
          this.model.ApproximateAvailabilities[0].Selected = false;
        }
      }

    }
  };
</script>



// WEBPACK FOOTER //
// src/components/MyProfile.vue